
























import Vue from 'vue';
import Component from 'vue-class-component';
import {State} from 'vuex-class';
import {BulkProcessState, default as Process} from '@/modules/reservation/model/BulkProcess';

@Component({
    filters: {
        toFixed: (value: number) => {
            return value.toFixed(2)
        },
    },
})
export default class BulkProcess extends Vue {
    @State(state => state.reservation.bulkProcess)
    public bulkProcess: Process

    public progress = 0

    public messages = {
        [BulkProcessState.Waiting]: 'Esperando',
        [BulkProcessState.Preparing]: 'Preparando',
        [BulkProcessState.Inserting]: 'Insertando',
        [BulkProcessState.Finished]: 'Finalizado',
    }

    public get finished () {
        return this.bulkProcess.state === BulkProcessState.Finished
    }

    public get disabled () {
        return this.bulkProcess.state !== BulkProcessState.Finished
    }
}
